module.exports = __webpack_public_path__ + "img/background-sidenav.69461477.png";